/**
 * Do a Places API search to return a list of locations.
 *
 * @param {string} apiKey
 * @param {string} [dataSourceId]
 * @param {object} args
 * @param {number} [args.lat]
 * @param {number} [args.lng]
 * @param {number} [args.radius]
 * @param {number} [args.limit]
 * @param {string} [args.activityPrefLabel]
 */
export async function apiPlacesSearch(
  apiKey,
  dataSourceId,
  { lat = 51.5211, lng = 0.1166, radius = 1000, activityPrefLabel }
) {
  const queryParams = {
    'geo[radial]': `${lat},${lng},${radius}`,
    limit: '50',
    ...(dataSourceId ? { dataSourceId } : {}),
    ...(activityPrefLabel ? { activityPrefLabel } : {}),
  };
  const queryString = new URLSearchParams(queryParams).toString();
  const url = `${process.env.REACT_APP_PLACES_API_URL}/api/v1/places?${queryString}`;
  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'X-API-KEY': apiKey,
      },
      mode: 'cors',
    });
    return await response.json();
  } catch (error) {
    // TODO: This should lead to a user-facing error notice (sorry, try again later)
    return {};
  }
}
